import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import storage from 'redux-persist/lib/storage'

import { persistReducer } from 'redux-persist'
import authSlice from './auth/slices/index.slices'
import walletSlice from './wallets/slices/index.slices'

import transactionsSlice from './transactions/slices/index.slices'
import userSlice from './user/slices/index.slices'
import globalUiSlice from './ui/global/slices/index.slices'

import bonusEngineSlice from './bonus-engine/slices/index.slices'
import reportSlice from './reports/slices/index.slices'
import balanceReportSlice from './balance-report/slices/index.slices'
import wageringSlice from './wagering-contribution/slices/index.slices'

import brandsSlice from './brands/slices/index.slices'
import { personalizationSlice } from './personalization-engine'
import { excludedGamesSlice } from './excluded-games/slices/index.slices'

import { playerCardSlice } from './player-card/slices'
import { sportsROSlice } from './sports-ro-calculator'
import playerTransactionsSlice from './player-transactions/slices/index.slices'

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['isLoading', 'twoFactorStatus'],
}

const walletPersistConfig = {
  key: 'wallet',
  storage,
  whitelist: ['freePlaysCalculated'],
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    auth: persistReducer(authPersistConfig, authSlice.reducer),
    globalUi: globalUiSlice.reducer,
    user: userSlice.reducer,
    transaction: transactionsSlice.reducer,
    wallet: persistReducer(walletPersistConfig, walletSlice.reducer),
    bonusEngine: bonusEngineSlice.reducer,
    reports: reportSlice.reducer,
    balanceReport: balanceReportSlice.reducer,
    wagering: wageringSlice.reducer,
    brands: brandsSlice.reducer,
    personalizationEngine: personalizationSlice.reducer,
    excludedGames: excludedGamesSlice.reducer,
    playerCard: playerCardSlice.reducer,
    sportsRO: sportsROSlice.reducer,
    playerTransaction: playerTransactionsSlice.reducer,
  })

export default createRootReducer
